import {Component, Inject, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdService} from '@services/ad.service';

@Component({
  selector: 'app-edit-diag',
  templateUrl: './edit-diag.component.html',
  styleUrls: ['./edit-diag.component.scss']
})
export class EditDiagComponent {

    favorite: Favorite;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public adService: AdService,
        public dialogRef: MatDialogRef<EditDiagComponent>) {
        this.favorite = Object.assign({}, data.favorite);
        console.log(this.favorite.lot_copro)
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.favorite = this.adService.updateValues(this.favorite);
        this.dialogRef.close(this.favorite);
    }
}
